<template>
  <div class="base-input">
    <b-form-input
      ref="innerInput"
      :value="value"
      :name="name"
      @input="$emit('input', $event)"
      :placeholder="placeholder"
      :disabled="disabled"
      :id="id"
      @keyup.enter="$emit('success')"
    />
  </div>
</template>

<script>
import { BFormInput } from "bootstrap-vue";

export default {
  name: "BaseInput",
  components: { BFormInput },
  props: {
    value: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    setFocus() {
      this.$refs.innerInput.focus();
    },
  },
};
</script>
